<div class="mobile-form-wrapper bg-[#F1F7FE]">
	<div>
		<app-mobile-timeline-template-v2
			(goBack)="goBack(currentStep?.index)"
			[currentStep]="currentStep?.step"
			[description]="currentStep?.description"
			[previous]="currentStep?.previous"
			[title]="currentStep?.title"
			[total]="TOTAL_STEP">
		</app-mobile-timeline-template-v2>
	</div>
	<div class="mobile-content-bg">
		<div class="grow">
			<div [ngSwitch]="currentStep?.step">
				<div *ngSwitchCase="USERNAME">
					<div>
						<div>
							<app-kamona-input-field (emitInput)="setUsername($event)"
													[input]="usernameInput">
							</app-kamona-input-field>
						</div>
					</div>
				</div>
				<div *ngSwitchCase="PHONE_VERIFICATION">
					<div *ngIf="useOtp">
						<div>
							<app-password-input-box (emitInput)="setPin($event)">
							</app-password-input-box>
						</div>
						<div class="m-t-7">
							<div nz-row nzJustify="end">
								<app-otp-count-down (emitRetryAction)="validateUsername()"
													[countdownType]="CountdownType.KAMONA"
													[errorTimer]="suspensionReleaseTime">
								</app-otp-count-down>
							</div>
						</div>
						<div class="m-t-24">
							<app-ussd-board
								[ussdCode]="ussdCode">
							</app-ussd-board>
						</div>
					</div>
					<app-liveliness *ngIf="!useOtp" class="grow flex flex-col"
						[reference]="livelinessCheckReference" [identityProvider]="identityProvider"
						(nextStepMoved)="livelinessStepCompleted($event)"
						[isSubmitting]="submitting"
						[isMobileView]="true"
						[noBottomPadding]="true"
						[type]="feature"
						[username]="usernameInput?.getInput()">
					</app-liveliness>
				</div>
			</div>
		</div>
		<div>
			<div *ngIf="currentStep?.step === USERNAME else stepTwoButton">
				<div class="kamona-button-session">
					<app-kamona-custom-button (submitForm)="validateUsername()"
											  [isBlock]="true"
											  [isDisabled]="!disableUsernameButton"
											  [isSubmitting]="submitting"
											  text="Next">
					</app-kamona-custom-button>
				</div>
			</div>
			<ng-template #stepTwoButton>
				<div *ngIf="useOtp">
					<div class="kamona-button-session">
						<app-kamona-custom-button (submitForm)="validatePin()" [isBlock]="true"
												  [isDisabled]="!disableOtpButton || !isSuspensionOver"
												  [isSubmitting]="submitting"
												  text="Next">
						</app-kamona-custom-button>
					</div>
				</div>
			</ng-template>
		</div>
	</div>
</div>

